import script from "./ManagementResults.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManagementResults.vue?vue&type=script&lang=ts&setup=true"

import "./ManagementResults.vue?vue&type=style&index=0&id=62ed76e8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62ed76e8"]])

export default __exports__